mtl.alloy.factory.lazyLoad = (function($) {
    'use strict';

    var CATCHMENT_THRESHOLD = 200;

    var SCROLL_THROTTLE = 200;


    var scrollListener = null;

    var watchedElements = [];

    var needsPruning = false;


    /**
     * Return true if the given value is 'truthy'.
     */
    function isTruthy(v) {

        return !!v;

    }


    /**
     * Get the height of the browser viewport.
     */
    function getWindowHeight() {

        return (window.innerHeight || document.body.clientHeight) | 0;

    }


    /**
     * Test whether the given element is on-screen.
     */
    function isElementOnScreen(_element) {

        var _rect = _element.getBoundingClientRect();

        return (
            _rect.bottom > (0 - CATCHMENT_THRESHOLD) &&
            _rect.top < (getWindowHeight() + CATCHMENT_THRESHOLD)
        );

    }


    /**
     * Load the content of the given element.
     */
    function loadElement(_element) {

        var _content = $.parseHTML(
            $(_element).children('script').prop('innerHTML')
        )[0];

        $(_element).replaceWith(_content);

    }


    /**
     * Test and load the given element.
     */
    function testElement(_element, _index) {

        if (!isElementOnScreen(_element)) {
            return false;
        }

        loadElement(_element);

        if (_index != null && _index > -1) {
            watchedElements[_index | 0] = null;
            needsPruning = true;
        }

        return true;

    }


    /**
     * Test and load all elements.
     */
    function testElements() {

        for (var i = 0, ix = watchedElements.length; i < ix; i++) {

            var _element = watchedElements[i];
            if (_element) {
                testElement(_element, i);
            }

        }

        if (needsPruning) {

            watchedElements = watchedElements.filter(isTruthy);
            needsPruning = false;

            if (watchedElements.length === 0) {
                stopRunning();
            }

        }

    }


    /**
     * Start running the scroll-watcher.
     */
    function startRunning() {

        if (scrollListener) {
            return;
        }

        scrollListener = util.throttle(testElements, SCROLL_THROTTLE);
        $(window).on('scroll', scrollListener);

    }


    /**
     * Stop running the scroll-watcher.
     */
    function stopRunning() {

        if (!scrollListener) {
            return;
        }

        $(window).off('scroll', scrollListener);
        scrollListener = null;

    }


    /**
     * Start watching the given element.
     */
    function watchElement(_element) {

        if (testElement(_element)) {
            return;
        }

        watchedElements.push(_element);
        startRunning();

    }


    /**
     * Return the lazy-load factory function.
     */
    return function(element, options) {

        watchElement(element);

    };

}(jQuery));
